import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormInput } from '../form/input';
import { Text } from '../typography';
import { CheckBox } from '../form/checkbox';
import { useFieldArray, useFormContext } from 'react-hook-form';
const WEEKDAYS = [
    { day: 0, name: 'Monday' },
    { day: 1, name: 'Tuesday' },
    { day: 2, name: 'Wednesday' },
    { day: 3, name: 'Thursday' },
    { day: 4, name: 'Friday' },
    { day: 5, name: 'Saturday' },
    { day: 6, name: 'Sunday' },
];
export function BusinessHoursInput({ name }) {
    const { control, watch } = useFormContext();
    const { append, remove } = useFieldArray({
        control,
        name,
    });
    const businessHours = watch(name) || [];
    const handleToggleDay = (day) => {
        const index = businessHours.findIndex((hour) => hour.day_of_week === day);
        if (index !== -1) {
            remove(index);
        }
        else {
            append({ day_of_week: day, open: '09:00', close: '17:00' });
        }
    };
    return (_jsx("div", { className: "border border-border rounded-card-sm overflow-hidden", children: _jsx("div", { className: "divide-y divide-border", children: WEEKDAYS.map((weekday) => {
                const index = businessHours.findIndex((hour) => hour.day_of_week === weekday.day);
                const isOpen = index !== -1;
                return (_jsxs("div", { className: "p-stack-roomy space-y-stack", children: [_jsxs("div", { className: "flex items-center gap-stack", children: [_jsx(CheckBox, { id: `day-open-${weekday.day}`, value: isOpen, onChange: () => handleToggleDay(weekday.day) }), _jsx("label", { htmlFor: `day-open-${weekday.day}`, className: "text-body-sm font-medium text-fg-muted cursor-pointer", children: weekday.name }), _jsx(Text, { type: "xs", className: "text-fg-subtle ml-auto", children: isOpen ? 'Open' : 'Closed' })] }), isOpen && (_jsxs("div", { className: "grid grid-cols-[1fr_auto_1fr] gap-stack-tight items-center", children: [_jsxs("div", { children: [_jsx(Text, { type: "xs", className: "text-fg-subtle mb-stack-dense", children: "Open" }), _jsx(FormInput, { name: `${name}.${index}.open`, type: "time" })] }), _jsx("span", { className: "text-body-sm text-fg-subtle pt-stack-roomy", children: "to" }), _jsxs("div", { children: [_jsx(Text, { type: "xs", className: "text-fg-subtle mb-stack-dense", children: "Close" }), _jsx(FormInput, { name: `${name}.${index}.close`, type: "time" })] })] }))] }, weekday.day));
            }) }) }));
}
